import React from 'react';

function Container({
  children,
  style,
  ...props
}){
  return (
    <div
      style={{
        boxShadow: 'rgb(194, 186, 186) 7px 7px 5px -2px',
        border: '1px solid #c2baba',
        padding: '20px',
        borderRadius: '5px',
        ...style
      }}        
    >
      {children}
    </div>
  );
}

export default Container;